import React from "react";
import { Card, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { EnumSalesFilter, } from "@domains/salesFeatures/Common/entities/IFilterDataEntity";
import { config } from "@frameworks/salesjourney/config/domain";
import GenericTooltip from "../../../../shared-library/components/GenericTooltip";
var CriticalActivities = function (props) {
    var _a;
    var navigate = useNavigate();
    // const routeLeadDashboard = (subId: number, displayName?: string) => {
    var routeLeadDashboard = function (activity) {
        var filterData = {};
        // filterData.scheme = [parseInt(keysForCustomFunction[1])];
        if (activity.strflag === "upload") {
            filterData.searchFlag = "critical";
        }
        else if (activity.strflag === "subsource") {
            filterData.searchFlag = "critical";
            filterData.sourceId = activity.id1 ? [activity.id1] : []; //type number
            filterData.subSourceId = activity.id ? [activity.id] : []; //type string
            filterData.sourceIdLst = activity.id1
                ? [
                    {
                        id: activity.id1,
                        parentFilter: EnumSalesFilter.sourceId,
                        checked: true,
                        inputType: "dropdown",
                        filterKey: EnumSalesFilter.sourceIdLst,
                        name: activity.name1,
                    },
                ]
                : [];
            filterData.subSourceIdLst = activity.id
                ? [
                    {
                        id: parseInt(activity.id),
                        parentFilter: EnumSalesFilter.subSourceId,
                        checked: true,
                        inputType: "checkbox",
                        filterKey: EnumSalesFilter.subSourceIdLst,
                        name: activity.name,
                    },
                ]
                : [];
        }
        else if (activity.strflag === "category") {
            filterData.searchFlag = "critical";
            filterData.categoryId = activity.id ? [parseInt(activity.id)] : [];
            filterData.categoryIdLst = activity.id
                ? [
                    {
                        id: parseInt(activity.id),
                        parentFilter: EnumSalesFilter.categoryId,
                        checked: true,
                        inputType: "checkbox",
                        filterKey: EnumSalesFilter.categoryIdLst,
                        name: activity.name,
                    },
                ]
                : [];
        }
        return (config.applicationFolder +
            "dashboard/lead-dashboard?filterData=" +
            encodeURI(JSON.stringify(filterData)) +
            "&criticalActivity=" +
            true +
            "&isDateSkip=" +
            true +
            "&tabFlag=" +
            2);
        // navigate(
        //   "/dashboard/lead-dashboard?filterData=" +
        //     encodeURI(JSON.stringify(filterData)) +
        //     "&isDateSkip=" +
        //     true +
        //     "&tabFlag=" +
        //     2,
        //   { replace: true }
        // );
    };
    var routeToEditLead = function (leadId) {
        if (leadId)
            navigate("/dashboard/leadpage/" + window.btoa(leadId), {
                replace: true,
            });
    };
    return (React.createElement(Card, { className: "upcoming-activities" },
        React.createElement(Card.Header, { className: "no_bg border-bottom-0 DMSanBold_18_700 txt-midnight-blue d-flex" },
            React.createElement(GenericTooltip, { placement: "bottom", toolTipText: "Urgent", triggerType: "hover", toolTipClassName: "lead-table-tooltip", noButton: true, button: React.createElement("i", { className: "edel-icon-urgent-1 me-1" }) }),
            "Critical Activities"),
        React.createElement(Card.Body, null,
            React.createElement(Row, { className: "DMSans_16_500 txt-midnight-blue bg_aqua_white today" }, "Today"),
            React.createElement("div", { className: "scroll-event critical commonscroll-new" },
                React.createElement(Row, { className: "txt_blackOne1 activity critical" }, props.criticalActivities &&
                    ((_a = props.criticalActivities) === null || _a === void 0 ? void 0 : _a.length) > 0 ? (props.criticalActivities.map(function (activity, idx) {
                    return (React.createElement("div", { key: idx, className: "DMSanN_14_400 line-140 txt_blackOne1" },
                        React.createElement("i", { className: "edel-icon-right-arrow" }),
                        React.createElement("a", { className: " text-decoration-underline hand_cursor line-140 txt_blackOne1", href: activity.leadCount > 0
                                ? routeLeadDashboard(activity)
                                : "" },
                            activity.name,
                            " : ",
                            activity.leadCount)));
                })) : (React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "DMSanN_14_400 line-140" }, "No Critical Activities"))))))));
};
export default CriticalActivities;
